import { type WorkspaceMemberRole } from '@up2stay/up2promo-api-client';
import { useMemo } from 'react';

import { useCurrentWorkspace } from '@/core/store/workspace.store';

import { useMyMemberships } from './use-my-memberships';

interface UseWorkspaceMemberRoleResult {
  role?: WorkspaceMemberRole;
  isLoading: boolean;
}

/**
 * Hook to get the current user's role in the current workspace.
 * Display only (badges, labels) — do not use for authorization; use `usePermissions().can()` instead.
 */
export function useWorkspaceMemberRole(): UseWorkspaceMemberRoleResult {
  const currentWorkspace = useCurrentWorkspace();
  const { memberships, isLoading } = useMyMemberships();

  const role = useMemo(() => {
    if (!currentWorkspace) return undefined;
    const membership = memberships.find(
      (m) => m.workspace?.id === currentWorkspace.id,
    );
    return membership?.role;
  }, [currentWorkspace, memberships]);

  return { role, isLoading };
}
